export default __webpack_public_path__ + "static/media/nicky.40e56786.png";